<!-- <div class="d-flex align-items-end h-100">
  <div class="mb-3 buscador " [hidden]="!showSearchInput">
    <div class="input-group form-control search-wrapper">
      <input id="hea-search-input" [(ngModel)]="searchText" type="text"
        placeholder="{{ 'buttons.orders-filter' | translate }}" aria-label="Buscar" #searchBox matInput
        (keyup)="keyup($event)" class="placeholder-filter text" autocomplete="off" (blur)="showSearchInput = false"
        style="transition: width 0.8s; width: 400px;" />
      <div [hidden]="!showSearchInput && searchText && searchSuggestions.length" class="search-suggestions dropdown-suggestions">
        <ng-container *ngFor="let group of searchSuggestions">
          <ng-container *ngFor="let key of objectKeys(group)">
            <div>
              <div class="suggestion-group-header-alt">
                <i class="{{ group[key].icon }}"></i>
                {{ "titles-menu-pages."+key | lowercase | translate | titlecase }}
                ({{ group[key].items.length }})
              </div>
              <a *ngFor="let item of group[key].items" class="suggestion-item suggestion-item-link" [href]="item.link">
                <div>{{ item.data }}</div>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div> -->

<div #headerFilter class="d-flex align-items-end h-100">
  <div class="mb-3 buscador">
    <div class="input-group form-control search-wrapper">
      <input id="hea-search-input" [(ngModel)]="searchText" type="text"
        placeholder="{{ 'buttons.orders-filter' | translate }}" aria-label="Buscar" #searchBox matInput
        (keyup)="keyup($event)" class="placeholder-filter text" autocomplete="off"
        />
      <div [hidden]="!searchSuggestions.length" class="search-suggestions dropdown-suggestions">
        <ng-container *ngFor="let group of searchSuggestions">
          <ng-container *ngFor="let key of objectKeys(group)">
            <div>
              <div class="suggestion-group-header-alt">
                <i class="{{ group[key].icon }}"></i>
                {{ "titles-menu-pages."+key | lowercase | translate | titlecase }}
                ({{ group[key].items.length }})
              </div>
              <a *ngFor="let item of group[key].items" class="suggestion-item suggestion-item-link" [href]="item.link">
                <div>{{ item.data }}</div>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
